//
// Selected palettes from lospec
// https://lospec.com/palette-list
//
export default [
  {
    name: 'sweetie16', // https://lospec.com/palette-list/sweetie-16
    colors: [
      '#5d275d',
      '#b13e53',
      '#ef7d57',
      '#ffcd75',
      '#a7f070',
      '#38b764',
      '#257179',
      '#29366f',
      '#3b5dc9',
      '#41a6f6',
      '#73eff7',
      '#94b0c2',
      '#566c86',
      '#333c57',
    ],

    stroke: '#f4f4f4',
    background: '#1a1c2c',
    type: 'lospec',
  },
  {
    name: 'na16', // https://lospec.com/palette-list/na16
    colors: [
      '#8c8fae',
      '#584563',
      '#3e2137',
      '#9a6348',
      '#d79b7d',
      '#f5edba',
      '#c0c741',
      '#647d34',
      '#e4943a',
      '#9d303b',
      '#d26471',
      '#70377f',
      '#7ec4c1',
      '#34859d',
      '#17434b',
      '#1f0e1c',
    ],
    stroke: '#f5edba',
    background: '#1f0e1c',
    type: 'lospec',
  },
  {
    name: 'lost-century', // https://lospec.com/palette-list/lost-century
    colors: [
      '#d1b187',
      '#c77b58',
      '#ae5d40',
      '#79444a',
      '#4b3d44',
      '#ba9158',
      '#927441',
      '#4d4539',
      '#77743b',
      '#b3a555',
      '#d2c9a5',
      '#8caba1',
      '#4b726e',
      '#574852',
      '#847875',
      '#ab9b8e',
    ],
    type: 'lospec',
  },
  {
    name: 'nostalgic-dreams', // https://lospec.com/palette-list/nostalgic-dreams
    colors: ['#d9af80', '#b07972', '#524352', '#686887', '#7f9bb0', '#bfd4b0', '#90b870', '#628c70'],
    type: 'lospec',
  },
  {
    name: 'sls08', // https://lospec.com/palette-list/slso8
    colors: ['#0d2b45', '#203c56', '#544e68', '#8d697a', '#d08159', '#ffaa5e', '#ffd4a3', '#ffecd6'],
    type: 'lospec',
  },
  {
    name: 'rust-gold-8', // https://lospec.com/palette-list/rust-gold-8
    colors: ['#f6cd26', '#ac6b26', '#563226', '#331c17', '#bb7f57', '#725956', '#393939', '#202020'],
    type: 'lospec',
  },
  {
    name: 'ink-crimson', // https://lospec.com/palette-list/ink-crimson
    colors: [
      '#ff0546',
      '#9c173b',
      '#660f31',
      '#450327',
      '#270022',
      '#17001d',
      '#09010d',
      '#0ce6f2',
      '#0098db',
      '#1e579c',
    ],
    type: 'lospec',
  },
  {
    name: 'look-of-horror', // https://lospec.com/palette-list/look-of-horror
    colors: ['#0a202f', '#302d6a', '#871c3e', '#d32836'],
    type: 'lospec',
  },
  {
    name: 'cormorant14', // https://lospec.com/palette-list/cormorant14
    colors: [
      '#dc67b9',
      '#ffa3a2',
      '#fcf6e7',
      '#ff8e58',
      '#da6175',
      '#79396c',
      '#213756',
      '#26707a',
      '#24b8a0',
      '#8ee6a1',
      '#edd54f',
      '#6bae36',
      '#7da497',
      '#c8cdbb',
    ],
    type: 'lospec',
  },
  {
    name: 'midnight_ablaze',
    colors: ['#ff8274', '#d53c6a', '#7c183c', '#460e2b', '#31051e', '#1f0510', '#130208'],
    type: 'lospec',
  },
  {
    name: 'taliwan', // https://lospec.com/palette-list/taliwan
    colors: [
      '#f2eef1',
      '#ffa7bf',
      '#ec7d9b',
      '#e64667',
      '#a02552',
      '#75024d',
      '#2c0f30',
      '#e18434',
      '#ffa01b',
      '#ffbd20',
    ],
    type: 'lospec',
  },
  {
    name: 'spanish_sunset', // https://lospec.com/palette-list/spanish-sunset
    colors: ['#f5ddbc', '#fabb64', '#fd724e', '#a02f40', '#5f2f45'],
    type: 'lospec',
  },
  {
    name: 'late_night_bath', // https://lospec.com/palette-list/late-night-bath
    colors: ['#282d3c', '#5b5d70', '#74838c', '#ffc4b8', '#f69197'],
    type: 'lospec',
  },
  {
    name: 'vaporhaze', // https://lospec.com/palette-list/vaporhaze-16
    colors: [
      '#00474f',
      '#225054',
      '#475b58',
      '#6a645d',
      '#8e6e61',
      '#b17766',
      '#d4826b',
      '#f88c6e',
      '#156d8e',
      '#467b96',
      '#6b869b',
      '#8e8f9f',
      '#b199a3',
      '#d5a3a7',
      '#f8adac',
      '#ffbdbb',
    ],
    type: 'lospec',
  },
  {
    name: 'neon_reflection', // https://lospec.com/palette-list/dr-neon-reflection
    colors: [
      '#b1e2e7',
      '#5be4b9',
      '#10bdc6',
      '#517cb8',
      '#394072',
      '#7441ae',
      '#bb49d7',
      '#f69dbd',
      '#d8d272',
      '#f3ad58',
      '#e74a9d',
      '#af517a',
    ],
    type: 'lospec',
  },
  {
    name: '17pastels', // https://lospec.com/palette-list/17pastels
    colors: [
      '#373254',
      '#68356f',
      '#5e6b82',
      '#25718c',
      '#11abbe',
      '#69f6bf',
      '#eff0d7',
      '#f8e574',
      '#a3e75c',
      '#6d4442',
      '#a16557',
      '#f98bb7',
      '#c84c66',
      '#f79152',
      '#9b9c82',
      '#1c866d',
      '#59b15e',
    ],
    type: 'lospec',
  },
  {
    name: 'pollen8', // https://lospec.com/palette-list/pollen8
    colors: ['#73464c', '#ab5675', '#ee6a7c', '#ffa7a5', '#ffe07e', '#72dcbb', '#34acba'],
    type: 'lospec',
  },
  {
    name: 'neon_space', // https://lospec.com/palette-list/neon-space
    colors: ['#df0772', '#fe546f', '#ff9e7d', '#ffd080', '#0bffe6', '#01cbcf', '#0188a5', '#3e3264', '#352a55'],
    type: 'lospec',
  },
  {
    name: 'salad_bowl', // https://lospec.com/palette-list/salad-bowl
    colors: ['#541b3c', '#802040', '#a04040', '#c06040', '#e0e080', '#a0c040', '#60a040', '#206040', '#103040'],
    type: 'lospec',
  },
  {
    name: 'seafoam', // https://lospec.com/palette-list/seafoam
    colors: ['#37364e', '#355d69', '#6aae9d', '#b9d4b4', '#f4e9d4', '#d0baa9', '#9e8e91', '#5b4a68'],
    type: 'lospec',
  },
  {
    name: 'chasm', // https://lospec.com/palette-list/chasm
    colors: [
      '#85daeb',
      '#5fc9e7',
      '#5fa1e7',
      '#5f6ee7',
      '#4c60aa',
      '#444774',
      '#32313b',
      '#463c5e',
      '#5d4776',
      '#855395',
    ],
    type: 'lospec',
  },
  {
    name: 'soapy10', // https://lospec.com/palette-list/soapy-10
    colors: [
      '#54cea7',
      '#2ba4a6',
      '#0c6987',
      '#054b84',
      '#0d2147',
      '#ffb0bf',
      '#ff82bd',
      '#d74ac7',
      '#a825ba',
      '#682b9c',
    ],
    type: 'lospec',
  },
  {
    name: 'synthetic80s', // https://lospec.com/palette-list/synthetic-80s
    colors: ['#e46018', '#fcb800', '#008894', '#004058', '#290d28', '#9d2496', '#db24d4'],
    type: 'lospec',
  },
];
